module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Staff Efficiency"}}')
  delete Component.options._Ctor
}
